import { PromoBanner } from '@shipt/design-system-banner'
import { useQuerySubscriptionPlansGuest } from '@/features/account/services/SubscriptionAux/queries'
import {
  getAnnualPlan,
  getSingleDeliveryFee,
  getTrialEligible,
} from '@/features/account/services/SubscriptionAux/utils'
import { PlanInterval } from '@/features/account/services/SubscriptionAux/types'
import { trackElementViewed } from '@/features/shared/analytics/element'
import { DISPLAY_FORMAT } from '@/features/shared/constants/analytics'
import { ScrollIntoView } from '@/features/shared/components/ScrollIntoView'

export const PDPMembershipBanner = () => {
  const { data: plans, isError } = useQuerySubscriptionPlansGuest()

  const shouldUseFallbackCopy = isError && !plans
  const resolvedPlans = shouldUseFallbackCopy ? [] : (plans ?? [])

  const { annualCost } = getAnnualPlan(resolvedPlans)
  const { singleDeliveryFee } = getSingleDeliveryFee(resolvedPlans)
  const { isTrialEligible, trialEligibleDays } = getTrialEligible(
    resolvedPlans,
    PlanInterval.ANNUAL,
  )

  const { title, body } = isTrialEligible
    ? {
        title: `Skip the $${singleDeliveryFee} delivery fee`,
        body: `Try Shipt membership free for ${trialEligibleDays} days, then $${annualCost}/year. Available at checkout.`,
      }
    : {
        title: `Skip the $${singleDeliveryFee} delivery fee`,
        body: `Enjoy $0 delivery fees with Shipt membership ($${annualCost}/year). Available at checkout.`,
      }

  const isReady = Boolean(plans) || isError

  if (!isReady) return null

  return (
    <ScrollIntoView
      autoSize
      onInView={() =>
        trackElementViewed({
          content: DISPLAY_FORMAT.PDP_MEMBERSHIP_BANNER,
          message_goal: 'membership_conversion',
          display_format: DISPLAY_FORMAT.PDP_MEMBERSHIP_BANNER,
          type: 'banner',
        })
      }
    >
      <PromoBanner title={title} description={body} variant="neutral" />
    </ScrollIntoView>
  )
}
